import { WebStorageStateStore } from 'oidc-client';
import Config from 'services/config/local';

export default {
    ...Config.auth.openid,
    userStore: new WebStorageStateStore({
        store: window.localStorage
    })
};



// WEBPACK FOOTER //
// ./app/services/auth/auth.config.js